// Mock data for pharmaceutical products from Kindred Pharmaceuticals
export const mockProducts = [
  // Anti-Cough Syrups
  {
    id: "1",
    name: "Ambroxol & Terbutaline Cough Syrup",
    category: "Cough & Cold",
    description: "Effective cough syrup for relief from productive cough with bronchodilation",
    composition: "Each 5ml contains: Ambroxol HCl 15mg, Terbutalin Sulphate 1.25mg, Guaiphenesin 50mg, Menthol 0.5mg",
    dosage: "Adults: 10ml three times daily. Children (6-12 years): 5ml three times daily",
    usage: "Take after meals. Shake well before use. Measure with provided cup",
    precautions: "Consult doctor if pregnant or breastfeeding. Not recommended for children under 2 years",
    sideEffects: "Common: nausea, headache. Rare: allergic reactions, tremors",
    prescription: false,
    image: "/syrup-spoon.jpg",
    inStock: true
  },
  {
    id: "2",
    name: "Bromhexine & Terbutaline Cough Syrup",
    category: "Cough & Cold",
    description: "Expectorant and bronchodilator combination for respiratory relief",
    composition: "Each 5ml contains: Bromhexine HCl 4mg, Terbutalin Sulphate 1.25mg, Guaiphenesin 50mg, Menthol 2.5mg",
    dosage: "Adults: 10ml three times daily. Children: 5ml three times daily",
    usage: "Take after meals with plenty of water. Shake well before use",
    precautions: "Avoid if allergic to bromhexine. Consult doctor for prolonged cough",
    sideEffects: "Mild: gastrointestinal upset. Rare: skin rash, dizziness",
    prescription: false,
    image: "/syrup-spoon.jpg",
    inStock: true
  },
  {
    id: "3",
    name: "Dextromethorphan & Cetirizine Cough Syrup",
    category: "Cough & Cold",
    description: "Cough suppressant with antihistamine for dry cough and allergic symptoms",
    composition: "Each 5ml contains: Dextromethorphan HBr 10mg, Ambroxol HCl 15mg, Cetirizine HCl 5mg, Menthol 0.5mg",
    dosage: "Adults: 10ml 2-3 times daily. Not for children under 6 years without medical advice",
    usage: "Can be taken with or without food. Avoid driving after consumption",
    precautions: "May cause drowsiness. Avoid alcohol. Not for productive cough",
    sideEffects: "Common: drowsiness, dry mouth. Rare: dizziness, confusion",
    prescription: false,
    image: "/syrup-spoon.jpg",
    inStock: true
  },
  
  // Analgesic Suspensions
  {
    id: "4",
    name: "Paracetamol Suspension 250mg",
    category: "Analgesics",
    description: "Effective pain and fever relief suspension for children and adults",
    composition: "Each 5ml contains: Paracetamol 250mg",
    dosage: "Children (6-12 years): 5-10ml every 4-6 hours. Maximum 4 doses in 24 hours",
    usage: "Shake well before use. Can be taken with or without food",
    precautions: "Do not exceed recommended dose. Avoid alcohol. Check for paracetamol in other medicines",
    sideEffects: "Rare: allergic reactions, liver damage with overdose",
    prescription: false,
    image: "/syrup-spoon.jpg",
    inStock: true
  },
  {
    id: "5",
    name: "Ibuprofen Suspension 100mg",
    category: "Analgesics",
    description: "Anti-inflammatory and pain relief suspension",
    composition: "Each 5ml contains: Ibuprofen 100mg",
    dosage: "Children: 5-10ml every 6-8 hours as needed. Maximum 30ml in 24 hours",
    usage: "Take with food or milk to reduce stomach upset. Shake well before use",
    precautions: "Not for children under 6 months. Avoid if allergic to NSAIDs",
    sideEffects: "Common: stomach upset. Rare: allergic reactions, GI bleeding",
    prescription: false,
    image: "/syrup-spoon.jpg",
    inStock: true
  },
  {
    id: "6",
    name: "Paracetamol & Mefenamic Acid Suspension",
    category: "Analgesics",
    description: "Combination analgesic for moderate to severe pain relief",
    composition: "Each 5ml contains: Paracetamol 125mg, Mefenamic Acid 50mg",
    dosage: "Children (6-12 years): 5ml three times daily after meals",
    usage: "Always take after meals. Shake well before use",
    precautions: "Not for prolonged use. Consult doctor if pain persists beyond 3 days",
    sideEffects: "Common: nausea, diarrhea. Rare: GI bleeding, allergic reactions",
    prescription: true,
    image: "/syrup-spoon.jpg",
    inStock: true
  },

  // Anticold Suspensions
  {
    id: "7",
    name: "Paracetamol & Phenylephrine Anticold Suspension",
    category: "Cough & Cold",
    description: "Multi-symptom cold and flu relief suspension",
    composition: "Each 5ml contains: Paracetamol 250mg, Phenylephrine HCl 5mg, CPM 2mg",
    dosage: "Adults: 10ml every 6 hours. Children (6-12 years): 5ml every 6 hours",
    usage: "Take after meals. Shake well before use. Measure accurately",
    precautions: "May cause drowsiness. Avoid driving. Not for children under 6 without medical advice",
    sideEffects: "Common: drowsiness, dry mouth. Rare: increased heart rate",
    prescription: false,
    image: "/syrup-spoon.jpg",
    inStock: true
  },
  {
    id: "8",
    name: "Paracetamol & Cetirizine Anticold Suspension",
    category: "Cough & Cold",
    description: "Cold relief with antihistamine for allergic symptoms",
    composition: "Each 5ml contains: Paracetamol 125mg, Phenylephrine HCl 2.5mg, Cetirizine HCl 2.5mg",
    dosage: "Children (2-6 years): 2.5ml twice daily. (6-12 years): 5ml twice daily",
    usage: "Can be taken with or without food. Best taken in the evening",
    precautions: "May cause drowsiness. Avoid with other antihistamines",
    sideEffects: "Common: drowsiness, headache. Rare: dry mouth",
    prescription: false,
    image: "/syrup-spoon.jpg",
    inStock: true
  },

  // Gastro & Anti-Spasmodic
  {
    id: "9",
    name: "Antacid Gel Suspension",
    category: "Gastric",
    description: "Fast-acting antacid for heartburn and acid indigestion relief",
    composition: "Each 5ml contains: Aluminium Hydroxide Gel 0.291gm, Magnesium Hydroxide 98mg, Oxetacaine 10mg",
    dosage: "Adults: 5-10ml 3-4 times daily, preferably 1 hour after meals and at bedtime",
    usage: "Shake well before use. Can be taken directly or diluted with water",
    precautions: "Avoid prolonged use. Consult doctor if symptoms persist beyond 2 weeks",
    sideEffects: "Common: constipation or diarrhea. Rare: allergic reactions",
    prescription: false,
    image: "/syrup-spoon.jpg",
    inStock: true
  },
  {
    id: "10",
    name: "Dicyclomine & Simethicone Drops",
    category: "Gastric",
    description: "Anti-spasmodic and anti-flatulent for infant colic relief",
    composition: "Each ml contains: Dicyclomine HCl 10mg, Simethicone 40mg",
    dosage: "Infants: 0.5-1ml three times daily before feeds",
    usage: "Can be mixed with water or milk. Shake well before use",
    precautions: "For infants above 6 months. Consult pediatrician before use",
    sideEffects: "Rare: drowsiness, constipation",
    prescription: false,
    image: "/syrup-spoon.jpg",
    inStock: true
  },
  {
    id: "11",
    name: "Sucralfate Suspension",
    category: "Gastric",
    description: "Gastric mucosal protectant for ulcer healing",
    composition: "Each 5ml contains: Sucralfate 1gm",
    dosage: "Adults: 5-10ml four times daily on empty stomach, 1 hour before meals",
    usage: "Shake well before use. Take on empty stomach for best results",
    precautions: "May interfere with absorption of other medications. Take other drugs 2 hours before",
    sideEffects: "Common: constipation. Rare: dry mouth, nausea",
    prescription: true,
    image: "/syrup-spoon.jpg",
    inStock: true
  },
  {
    id: "12",
    name: "Ondansetron Suspension 2mg",
    category: "Gastric",
    description: "Anti-emetic for nausea and vomiting relief",
    composition: "Each 5ml contains: Ondansetron HCl 2mg",
    dosage: "Children (6 months-1 year): 2ml twice daily. (1-12 years): 4ml 2-3 times daily",
    usage: "Can be taken with or without food. Shake well before use",
    precautions: "Consult doctor for prolonged vomiting or if dehydration present",
    sideEffects: "Common: headache, constipation. Rare: dizziness",
    prescription: true,
    image: "/syrup-spoon.jpg",
    inStock: true
  },
  {
    id: "13",
    name: "Lactulose Solution",
    category: "Gastric",
    description: "Gentle laxative for constipation relief",
    composition: "Each 5ml contains: Lactulose 3.335gm",
    dosage: "Adults: 15-30ml daily. Children: 5-15ml daily, adjusted as needed",
    usage: "Can be taken directly or diluted with water or juice",
    precautions: "Increase fluid intake. May take 24-48 hours to show effect",
    sideEffects: "Common: bloating, gas, abdominal cramps initially",
    prescription: false,
    image: "/syrup-spoon.jpg",
    inStock: true
  },

  // Antihistamines
  {
    id: "14",
    name: "Levocetirizine Solution 2.5mg",
    category: "Antihistamine",
    description: "Advanced antihistamine for allergic rhinitis and urticaria",
    composition: "Each 5ml contains: Levocetirizine HCl 2.5mg",
    dosage: "Adults & children over 6 years: 5-10ml once daily in the evening",
    usage: "Can be taken with or without food. Best taken in the evening",
    precautions: "May cause drowsiness. Avoid driving initially. Not for children under 2 years",
    sideEffects: "Common: drowsiness, dry mouth. Rare: headache, fatigue",
    prescription: false,
    image: "/syrup-spoon.jpg",
    inStock: true
  },
  {
    id: "15",
    name: "Montelukast & Levocetirizine Suspension",
    category: "Antihistamine",
    description: "Combination therapy for allergic rhinitis and asthma",
    composition: "Each 5ml contains: Montelukast 4mg, Levocetirizine Di Hydrochloride 2.5mg",
    dosage: "Children (2-6 years): 5ml once daily at bedtime",
    usage: "Take in the evening with or without food",
    precautions: "Continue as prescribed even if symptoms improve. Monitor for mood changes",
    sideEffects: "Common: drowsiness, headache. Rare: behavioral changes",
    prescription: true,
    image: "/syrup-spoon.jpg",
    inStock: true
  },

  // Antibiotics & Others
  {
    id: "16",
    name: "Ofloxacin & Metronidazole Suspension",
    category: "Antibiotics",
    description: "Broad-spectrum antibiotic combination for bacterial and protozoal infections",
    composition: "Each 5ml contains: Ofloxacin 50mg, Metronidazole Benzoate 100mg",
    dosage: "Children (6-12 years): 5ml twice daily. Adults: 10ml twice daily",
    usage: "Take after meals. Complete full course as prescribed",
    precautions: "Avoid alcohol during treatment and for 48 hours after. Not for children under 2 years",
    sideEffects: "Common: nausea, diarrhea. Rare: metallic taste, photosensitivity",
    prescription: true,
    image: "/syrup-spoon.jpg",
    inStock: true
  },
  {
    id: "17",
    name: "Albendazole Suspension 200mg",
    category: "Antiparasitic",
    description: "Broad-spectrum anthelmintic for intestinal worm infections",
    composition: "Each 5ml contains: Albendazole 200mg",
    dosage: "Adults & children over 2 years: 10ml single dose (repeat after 2 weeks if needed)",
    usage: "Take with fatty meal for better absorption. Can be crushed or chewed",
    precautions: "Not for pregnant women. All family members should be treated simultaneously",
    sideEffects: "Common: abdominal pain, nausea. Rare: headache, dizziness",
    prescription: true,
    image: "/syrup-spoon.jpg",
    inStock: true
  },

  // Drops
  {
    id: "18",
    name: "Paracetamol Drops 100mg",
    category: "Analgesics",
    description: "Infant pain and fever relief drops",
    composition: "Each ml contains: Paracetamol 100mg",
    dosage: "Infants (3-12 months): 0.6ml every 4-6 hours. Maximum 4 doses daily",
    usage: "Can be given directly or mixed with water/milk. Use dropper provided",
    precautions: "Consult pediatrician for infants under 3 months. Do not exceed recommended dose",
    sideEffects: "Rare: allergic reactions",
    prescription: false,
    image: "/syrup-spoon.jpg",
    inStock: true
  },
  {
    id: "19",
    name: "Vitamin D3 Drops 800 IU",
    category: "Supplements",
    description: "Essential vitamin D supplementation for infants and children",
    composition: "Each ml contains: Vitamin D3 800 IU (20mcg as Cholecalciferol)",
    dosage: "Infants & children: 1ml (800 IU) daily or as directed by pediatrician",
    usage: "Can be given directly into mouth or mixed with milk/food",
    precautions: "Do not exceed recommended dose. Monitor if taking other vitamin D supplements",
    sideEffects: "Rare: hypercalcemia with excessive dosing",
    prescription: false,
    image: "/syrup-spoon.jpg",
    inStock: true
  },

  // Tonics
  {
    id: "20",
    name: "Appetite Stimulant Tonic",
    category: "Supplements",
    description: "Comprehensive appetite stimulant for improved nutrition",
    composition: "Each 5ml contains: Tricholine Citrate 275mg, Cyproheptadine HCl 2mg, Sorbitol 70% 3.575gm",
    dosage: "Children (2-6 years): 5ml twice daily before meals. (6-12 years): 5-10ml twice daily",
    usage: "Take 30 minutes before meals for best results",
    precautions: "May cause drowsiness. Not for children under 2 years without medical advice",
    sideEffects: "Common: increased appetite, drowsiness. Rare: dry mouth",
    prescription: false,
    image: "/syrup-spoon.jpg",
    inStock: true
  },
  {
    id: "21",
    name: "Digestive Enzyme Tonic",
    category: "Supplements",
    description: "Digestive enzyme supplement for improved digestion",
    composition: "Each 5ml contains: Diastase (1:1200) 50mg, Pepsin (1:3000) 10mg",
    dosage: "Adults: 10ml three times daily after meals. Children: 5ml three times daily",
    usage: "Take immediately after meals for optimal enzyme activity",
    precautions: "Store in cool place. Shake well before use",
    sideEffects: "Rare: mild gastrointestinal discomfort",
    prescription: false,
    image: "/syrup-spoon.jpg",
    inStock: true
  },

  // Iron & Vitamin Supplements
  {
    id: "22",
    name: "HEMWEL Syrup",
    category: "Supplements",
    description: "Iron supplement with Vitamin B12 for anemia treatment",
    composition: "Each 15ml contains: Ferric Ammonium Citrate 250mg, Vitamin B12 5mcg, Folic Acid 0.5mg",
    dosage: "Adults: 15ml twice daily after meals. Children (6-12 years): 15ml once daily",
    usage: "Take after meals with water or fruit juice. Shake well before use",
    precautions: "May cause temporary staining of teeth. Use straw if needed. Not for iron overload conditions",
    sideEffects: "Common: constipation, dark stools, stomach upset. Rare: allergic reactions",
    prescription: false,
    image: "/syrup-spoon.jpg",
    inStock: true
  },
  {
    id: "23",
    name: "NEWREETONE Syrup",
    category: "Supplements",
    description: "Ferric ferrous fumarate with B12 for iron deficiency",
    composition: "Each 5ml contains: Ferric Ferrous Fumarate 100mg, Vitamin B12 5mcg, Folic Acid 0.5mg",
    dosage: "Adults: 5-10ml twice daily. Children: 5ml once daily or as directed",
    usage: "Take after meals. Can be diluted with water or juice",
    precautions: "Keep out of reach of children. Overdose of iron can be fatal in children",
    sideEffects: "Common: nausea, constipation, dark stools",
    prescription: false,
    image: "/syrup-spoon.jpg",
    inStock: true
  },
  {
    id: "24",
    name: "FEFARI-XT Syrup",
    category: "Supplements",
    description: "Ferrous ascorbate with folic acid for enhanced iron absorption",
    composition: "Each 5ml contains: Ferrous Ascorbate 30mg, Folic Acid 550mcg",
    dosage: "Adults: 5-10ml once or twice daily. Pregnant women: As prescribed by physician",
    usage: "Best absorbed on empty stomach, but can be taken with food if stomach upset occurs",
    precautions: "Essential during pregnancy and lactation. Consult doctor for dosage adjustment",
    sideEffects: "Mild: stomach upset, nausea. Rare: constipation",
    prescription: false,
    image: "/syrup-spoon.jpg",
    inStock: true
  },
  {
    id: "25",
    name: "VITATON PLUS HEAM Syrup",
    category: "Supplements",
    description: "Comprehensive iron and vitamin supplement with lysine",
    composition: "Each 15ml contains: Ferric Ammonium Citrate 200mg, Vitamin B12 5mcg, Folic Acid 1mg, L-Lysine 12mg, Vitamin B6 2mg",
    dosage: "Adults: 15ml twice daily after meals. Children: 15ml once daily",
    usage: "Take after meals. Shake well before use",
    precautions: "Monitor hemoglobin levels during treatment. Not for hemochromatosis",
    sideEffects: "Common: mild GI disturbance, dark stools",
    prescription: false,
    image: "/syrup-spoon.jpg",
    inStock: true
  },

  // Protein & Multivitamin Supplements
  {
    id: "26",
    name: "MAPVIT Syrup (WELPRO-12)",
    category: "Supplements",
    description: "Protein hydrolysate with multivitamins and minerals for growth",
    composition: "Each 15ml contains: Protein Hydrolysate 1gm, Vitamin B1 0.5mg, B2 0.5mg, B6 0.5mg, B12 0.25mcg, D-Panthenol 1mg, Iron Choline Citrate 50mg, Folic Acid 0.1mg, Niacinamide 8mg, Magnesium Chloride 10mg, Manganese Chloride 0.1mg, Sorbitol 0.75gm",
    dosage: "Children (2-6 years): 5ml twice daily. (6-12 years): 10ml twice daily. Adults: 15ml twice daily",
    usage: "Take after meals. Can be taken directly or mixed with milk/juice",
    precautions: "Consult doctor if diabetic due to sorbitol content",
    sideEffects: "Rare: allergic reactions to protein",
    prescription: false,
    image: "/syrup-spoon.jpg",
    inStock: true
  },
  {
    id: "27",
    name: "PROFIT Syrup (PROPLEX/PROTAMIN)",
    category: "Supplements",
    description: "Protein supplement with B-complex vitamins and iron",
    composition: "Each 15ml contains: Protein Hydrolysate 1gm, Vitamin B1 0.5mg, B2 0.5mg, B6 0.5mg, B12 0.25mcg, D-Panthenol 1mg, Iron Choline Citrate 50mg, Niacinamide 8mg",
    dosage: "Children: 5-10ml twice daily. Adults: 15ml twice daily",
    usage: "Take with or after meals. Suitable for convalescence and nutritional supplementation",
    precautions: "Store in cool dry place. Shake well before use",
    sideEffects: "Generally well tolerated. Rare: mild stomach upset",
    prescription: false,
    image: "/syrup-spoon.jpg",
    inStock: true
  },
  {
    id: "28",
    name: "Multivitamin Syrup",
    category: "Supplements",
    description: "Complete multivitamin supplement for daily nutrition",
    composition: "Each 5ml contains: Nicotinamide 20mg, Ascorbic Acid (Vit C) 15mg, Thiamine HCl (B1) 1mg, Vitamin D3 100 IU, Vitamin A 500 IU, Riboflavin (B2) 0.5mg",
    dosage: "Adults: 10ml once daily. Children (6-12 years): 5ml once daily",
    usage: "Take with or after meals for better absorption",
    precautions: "Do not exceed recommended dose. Consult doctor if taking other supplements",
    sideEffects: "Rare: allergic reactions, stomach upset",
    prescription: false,
    image: "/syrup-spoon.jpg",
    inStock: true
  },
  {
    id: "29",
    name: "Vitamin B-Complex with Iron Syrup",
    category: "Supplements",
    description: "B-complex vitamins with iron and zinc for overall health",
    composition: "Each 5ml contains: Vitamin B12 5mcg, Zinc Sulphate 30mg, Ferric Ammonium Citrate 160mg, Folic Acid 1mg",
    dosage: "Adults: 5-10ml once daily. Children: 5ml once daily",
    usage: "Take after meals with water",
    precautions: "May interact with certain antibiotics. Consult doctor if on medication",
    sideEffects: "Common: mild nausea, metallic taste",
    prescription: false,
    image: "/syrup-spoon.jpg",
    inStock: true
  },
  {
    id: "30",
    name: "Vitamin D3 SOLU Oral Solution 60000 IU",
    category: "Supplements",
    description: "High-dose vitamin D3 for severe deficiency treatment",
    composition: "Each 5ml contains: Vitamin D3 (Cholecalciferol) 60000 IU",
    dosage: "Adults: 5ml once weekly or as prescribed. Treatment duration: 8-12 weeks",
    usage: "Take with fatty meal for better absorption. Can be taken directly or mixed with milk",
    precautions: "Prescription medicine for severe vitamin D deficiency. Monitor calcium and vitamin D levels",
    sideEffects: "Rare: hypercalcemia with overdose, nausea, weakness",
    prescription: true,
    image: "/syrup-spoon.jpg",
    inStock: true
  },

  // Antibiotics
  {
    id: "31",
    name: "Azithromycin Suspension 200mg",
    category: "Antibiotics",
    description: "Macrolide antibiotic for respiratory and soft tissue infections",
    composition: "Each 5ml contains: Azithromycin 200mg",
    dosage: "Children: 10mg/kg once daily for 3 days. Adults: As prescribed by physician",
    usage: "Shake well before use. Can be taken with or without food. Complete full course",
    precautions: "Not for patients allergic to macrolide antibiotics. Inform doctor of heart conditions",
    sideEffects: "Common: diarrhea, nausea, stomach pain. Rare: allergic reactions",
    prescription: true,
    image: "/syrup-spoon.jpg",
    inStock: true
  },

  // Additional Specialized Products
  {
    id: "32",
    name: "Hydroxyzine HCl Syrup",
    category: "Antihistamine",
    description: "Antihistamine and anxiolytic for allergies and anxiety",
    composition: "Each 5ml contains: Hydroxyzine HCl 10mg",
    dosage: "Adults: 10-25ml three times daily. Children (6-12 years): 10-15ml daily in divided doses",
    usage: "Take with or without food. May be taken at bedtime for sedative effect",
    precautions: "May cause drowsiness. Avoid alcohol and driving. Not for early pregnancy",
    sideEffects: "Common: drowsiness, dry mouth. Rare: tremor, confusion",
    prescription: true,
    image: "/syrup-spoon.jpg",
    inStock: true
  },
  {
    id: "33",
    name: "Chloroquine Phosphate Syrup",
    category: "Antimalarial",
    description: "Antimalarial medication for malaria treatment and prophylaxis",
    composition: "Each 5ml contains: Chloroquine Phosphate 80mg",
    dosage: "Adults: As per physician's prescription based on body weight. Children: Weight-based dosing",
    usage: "Take with food to minimize stomach upset. Complete full course as prescribed",
    precautions: "Regular eye examinations needed for prolonged use. Not for patients with retinal disease",
    sideEffects: "Common: nausea, stomach pain, headache. Rare: vision changes, seizures",
    prescription: true,
    image: "/syrup-spoon.jpg",
    inStock: true
  },
  {
    id: "34",
    name: "Levofloxacin Suspension 125mg",
    category: "Antibiotics",
    description: "Fluoroquinolone antibiotic for bacterial infections",
    composition: "Each 5ml contains: Levofloxacin 125mg",
    dosage: "Children: As prescribed by physician. Adults: 250-500mg once or twice daily",
    usage: "Take on empty stomach. Drink plenty of fluids. Avoid dairy products within 2 hours",
    precautions: "Not recommended for children. May cause tendon problems. Avoid excessive sun exposure",
    sideEffects: "Common: nausea, diarrhea. Rare: tendon rupture, photosensitivity",
    prescription: true,
    image: "/syrup-spoon.jpg",
    inStock: true
  },
  {
    id: "35",
    name: "Potassium Citrate & Citric Acid Solution",
    category: "Urinary Alkalinizer",
    description: "Urinary alkalinizer for kidney stones and UTI management",
    composition: "Each 5ml contains: Potassium Citrate 1100mg, Citric Acid 334mg",
    dosage: "Adults: 10-15ml three times daily diluted in water after meals",
    usage: "Always dilute in a glass of water before drinking. Take after meals",
    precautions: "Not for patients with kidney failure or high potassium levels. Monitor electrolytes",
    sideEffects: "Common: stomach upset, nausea. Rare: hyperkalemia",
    prescription: false,
    image: "/syrup-spoon.jpg",
    inStock: true
  }
];

export const categories = [
  "All Products",
  "Cough & Cold",
  "Analgesics",
  "Gastric",
  "Antihistamine",
  "Antibiotics",
  "Antiparasitic",
  "Antimalarial",
  "Urinary Alkalinizer",
  "Supplements"
];
